import { z } from 'zod'
import type { ApiClient } from '../apiClient'

export const ratioDimApplicabilityRowSchema = z.object({
  ratio_kpi: z.string(),
  dim_name: z.string(),
  dim_class: z.string(),
  in_num: z.boolean(),
  in_denom: z.boolean(),
  num_label: z.string().nullable(),
  denom_label: z.string().nullable(),
})
export type RatioDimApplicabilityRow = z.infer<typeof ratioDimApplicabilityRowSchema>
const schema = z.array(ratioDimApplicabilityRowSchema)

export async function getRatioDimApplicability(
  client: ApiClient,
  ratioKpi: string,
): Promise<RatioDimApplicabilityRow[]> {
  const raw = await client.get<unknown>('/v_ratio_dim_applicability', {
    ratio_kpi: `eq.${ratioKpi}`,
  })
  return schema.parse(raw)
}
